import React from 'react'
import { SignUp } from '@clerk/clerk-react'

export default function SignUpPage() {
  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white font-bold text-xl mx-auto mb-4">
            ت
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Create your account</h1>
          <p className="text-gray-400">Start mastering tajweed with AI — free</p>
        </div>
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'bg-gray-900 border border-gray-800 shadow-2xl',
              headerTitle: 'text-white',
              headerSubtitle: 'text-gray-400',
              formFieldLabel: 'text-gray-300',
              formFieldInput: 'bg-gray-800 border-gray-700 text-white placeholder-gray-500',
              formButtonPrimary: 'bg-emerald-600 hover:bg-emerald-500',
              footerActionLink: 'text-emerald-400 hover:text-emerald-300',
              identityPreviewEditButton: 'text-emerald-400',
              formFieldAction: 'text-emerald-400',
              dividerLine: 'bg-gray-700',
              dividerText: 'text-gray-500',
              socialButtonsBlockButton: 'bg-gray-800 border-gray-700 text-gray-200 hover:bg-gray-700',
              socialButtonsBlockButtonText: 'text-gray-200',
              otpCodeFieldInput: 'bg-gray-800 border-gray-700 text-white',
            },
          }}
        />
      </div>
    </div>
  )
}
